"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeSubtitle = exports.getCategories = exports.getDates = exports.getLayouts = exports.getParentValues = exports.getNodeValues = exports.BREAKDOWN_PADDING = exports.GROUP_PADDING = void 0;
const lodash_1 = __importDefault(require("lodash"));
const utilities_1 = require("../../../utilities");
const date_1 = require("../../../utilities/date");
exports.GROUP_PADDING = 3;
exports.BREAKDOWN_PADDING = 3;
const layoutNode = function () {
  let {
    key,
    value,
    label = key,
    color = 'red'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let total = arguments.length > 1 ? arguments[1] : undefined;
  let yOffset = arguments.length > 2 ? arguments[2] : undefined;
  let width = arguments.length > 3 ? arguments[3] : undefined;
  let nodeHeight = arguments.length > 4 ? arguments[4] : undefined;
  let padding = arguments.length > 5 ? arguments[5] : undefined;
  let accX = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  const nodeWidth = total === 0 ? 0 : width * value / total;
  return {
    layout: {
      key,
      color,
      label,
      value,
      x: accX,
      y: yOffset,
      width: nodeWidth,
      height: nodeHeight
    },
    acc: accX + nodeWidth + padding
  };
};
const getValueFromBreakdown = function () {
  let {
    metrics = []
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 ? arguments[1] : undefined;
  let category = arguments.length > 2 ? arguments[2] : undefined;
  let date = arguments.length > 3 ? arguments[3] : undefined;
  const metricByCategory = metrics.find(_ref => {
    let {
      name
    } = _ref;
    return name === category;
  });
  const {
    id
  } = metricByCategory || {};
  const metric = data.find(_ref2 => {
    let {
      id: dataID
    } = _ref2;
    return dataID === id;
  });
  const {
    data: metricData = [],
    x_type
  } = metric || {};
  const {
    value
  } = metricData.find(_ref3 => {
    let {
      key
    } = _ref3;
    return (0, date_1.dateParser)(key, x_type).getTime() === date.getTime();
  }) || {};
  return value;
};
const getGroupsLayout = (breakdown, groups, data, width, nodeHeight, xOffset, yOffset, category, date) => {
  const layouts = [];
  const sumGroupValues = (sum, node) => {
    const value = getValueFromBreakdown(node, data, category, date);
    if (isNaN(value)) {
      return sum;
    }
    return sum + value;
  };
  const groupValues = (0, lodash_1.default)(breakdown).groupBy('group').mapValues(function () {
    let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return lodash_1.default.reduce(values, sumGroupValues, 0);
  }).value();
  // Used to normalize values since totals doesn't always sum up to 1
  const totalValue = (0, lodash_1.default)(groupValues).values().sum();
  let x = xOffset;
  const availableWidth = width - (groups.length - 1) * exports.GROUP_PADDING;
  groups.forEach(group => {
    const {
      layout,
      acc
    } = layoutNode({
      ...group,
      value: groupValues[group.key]
    }, totalValue, yOffset, availableWidth, nodeHeight, exports.GROUP_PADDING, x);
    layouts.push(layout);
    x = acc;
  });
  return layouts;
};
const getBreakdownLayout = (breakdown, data, groupsLayout, nodeHeight, category, date) => {
  const layouts = [];
  const groups = (0, lodash_1.default)(breakdown).groupBy('group').map(function () {
    let breakdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let key = arguments.length > 1 ? arguments[1] : undefined;
    return {
      key,
      breakdown
    };
  }).value();
  groups.forEach(group => {
    const groupLayout = groupsLayout.find(_ref4 => {
      let {
        key
      } = _ref4;
      return key === group.key;
    });
    if (groupLayout === undefined) {
      return;
    }
    const {
      x,
      y,
      height,
      value: groupValue,
      width,
      color
    } = groupLayout;
    let xOffset = x;
    const yOffset = y + height + exports.BREAKDOWN_PADDING;
    const availableWidth = width - (group.breakdown.length - 1) * exports.BREAKDOWN_PADDING;
    group.breakdown.forEach(node => {
      const value = getValueFromBreakdown(node, data, category, date);
      const {
        layout,
        acc
      } = layoutNode({
        ...node,
        value,
        color
      }, groupValue, yOffset, availableWidth, nodeHeight, exports.BREAKDOWN_PADDING, xOffset);
      layouts.push(layout);
      xOffset = acc;
    });
  });
  return layouts;
};
const getBreakdownValues = (key, breakdowns, data, date) => {
  const breakdown = lodash_1.default.find(breakdowns, _ref5 => {
    let {
      key: breakdownKey
    } = _ref5;
    return breakdownKey === key;
  });
  return (0, lodash_1.default)(breakdown.metrics).map(_ref6 => {
    let {
      name,
      id
    } = _ref6;
    const datum = lodash_1.default.find(data, _ref7 => {
      let {
        id: dataID
      } = _ref7;
      return id === dataID;
    });
    const {
      data: values,
      x_type,
      y_type
    } = datum || {};
    const {
      value
    } = lodash_1.default.find(values, function () {
      let {
        key
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, date_1.dateParser)(key, x_type).getTime() === date.getTime();
    }) || {};
    return {
      name,
      value,
      format: y_type,
      formattedValue: (0, utilities_1.valueFormat)({
        params: {
          format: y_type
        }
      })(value)
    };
  }).value();
};
const getGroupValues = (key, breakdowns, data, date) => (0, lodash_1.default)(breakdowns).filter(_ref8 => {
  let {
    group
  } = _ref8;
  return group === key;
}).flatMap('metrics').groupBy('name').map((breakdown, name) => {
  const metrics = (0, lodash_1.default)(breakdown).map(_ref9 => {
    let {
      id
    } = _ref9;
    return lodash_1.default.find(data, _ref10 => {
      let {
        id: dataID
      } = _ref10;
      return id === dataID;
    });
  }).value();
  const y_types = lodash_1.default.map(metrics, 'y_type');
  const y_type = lodash_1.default.first(y_types);
  const value = (0, lodash_1.default)(metrics).map(function () {
    let {
      data: values,
      x_type
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return lodash_1.default.find(values, function () {
      let {
        key
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, date_1.dateParser)(key, x_type).getTime() === date.getTime();
    });
  }).sumBy('value');
  return {
    name,
    value,
    format: y_type,
    formattedValue: (0, utilities_1.valueFormat)({
      params: {
        format: y_type
      }
    })(value)
  };
}).value();
const getNodeValues = (nodeID, breakdown, data, date, type) => {
  const dates = (0, date_1.intersectingDates)(data);
  const {
    key: dateKey
  } = dates.find(_ref11 => {
    let {
      formatted
    } = _ref11;
    return date === formatted;
  }) || {};
  if (type === 'group') {
    return getGroupValues(nodeID, breakdown, data, dateKey);
  }
  return getBreakdownValues(nodeID, breakdown, data, dateKey);
};
exports.getNodeValues = getNodeValues;
const getParentValues = (nodeID, breakdowns, data, date) => {
  const dates = (0, date_1.intersectingDates)(data);
  const {
    key: dateKey
  } = dates.find(_ref12 => {
    let {
      formatted
    } = _ref12;
    return date === formatted;
  }) || {};
  const breakdown = breakdowns.find(_ref13 => {
    let {
      key
    } = _ref13;
    return key === nodeID;
  });
  if (breakdown === undefined) {
    return [];
  }
  const {
    group
  } = breakdown;
  return getGroupValues(group, breakdown, data, dateKey);
};
exports.getParentValues = getParentValues;
const getLayouts = function (breakdown, groups, data, width, nodeHeight, category, date, levelLabelsWidth) {
  let {
    top = 20,
    left = 0,
    right = 0
  } = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  const dates = (0, date_1.intersectingDates)(data);
  const {
    key: dateKey
  } = dates.find(_ref14 => {
    let {
      formatted
    } = _ref14;
    return date === formatted;
  }) || {};
  const marginX = levelLabelsWidth + left;
  const marginY = top;
  const nodesWidth = width - marginX - right;
  const groupLayout = getGroupsLayout(breakdown, groups, data, nodesWidth, nodeHeight, marginX, marginY, category, dateKey);
  const breakdownLayout = getBreakdownLayout(breakdown, data, groupLayout, nodeHeight, category, dateKey);
  return {
    groups: groupLayout,
    breakdowns: breakdownLayout
  };
};
exports.getLayouts = getLayouts;
const getDates = data => (0, date_1.intersectingDates)(data);
exports.getDates = getDates;
const getCategories = breakdown => {
  const allCategories = (0, lodash_1.default)(breakdown).map(_ref15 => {
    let {
      metrics
    } = _ref15;
    return (0, lodash_1.default)(metrics).map(_ref16 => {
      let {
        name
      } = _ref16;
      return name;
    }).filter(name => name).value();
  }).compact();
  return lodash_1.default.intersectionBy(...allCategories);
};
exports.getCategories = getCategories;
const getNodeSubtitle = function () {
  let nodeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let groups = arguments.length > 1 ? arguments[1] : undefined;
  let breakdowns = arguments.length > 2 ? arguments[2] : undefined;
  let category = arguments.length > 3 ? arguments[3] : undefined;
  let label = arguments.length > 4 ? arguments[4] : undefined;
  const group = groups.find(_ref17 => {
    let {
      key
    } = _ref17;
    return key === nodeID;
  });
  const breakdown = breakdowns.find(_ref18 => {
    let {
      key
    } = _ref18;
    return key === nodeID;
  });
  if (group === undefined && breakdown === undefined) {
    return '';
  }
  const {
    key = '',
    label: nodeLabel = key
  } = group || breakdown || {};
  return `${label} ${nodeLabel}, ${category}`;
};
exports.getNodeSubtitle = getNodeSubtitle;